import { render, staticRenderFns } from "./PageTab.vue?vue&type=template&id=55f6015b&scoped=true"
import script from "./PageTab.vue?vue&type=script&lang=js"
export * from "./PageTab.vue?vue&type=script&lang=js"
import style0 from "./PageTab.vue?vue&type=style&index=0&id=55f6015b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f6015b",
  null
  
)

export default component.exports